import React, { ComponentPropsWithoutRef } from 'react';

import { Typography } from '@rbx/ui';

type FigcaptionProps = ComponentPropsWithoutRef<'figcaption'>;

export default function MarkdownFigcaption({ children }: FigcaptionProps) {
  return (
    <figcaption>
      <Typography color='secondary' variant='captionHeader'>
        {children}
      </Typography>
    </figcaption>
  );
}
